import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import React from 'react';
import { ButtonV2 as Button } from '@/components/Button';
import Header from '../misc/Header';
import useSelections from '@/components/widget/misc/useSelections';
import { getEditingAreaAttr } from '@/components/Editor/hooks/useEditingAreas';
import Item from './Item';
import useData from './useData';
import useSubscribeWidgetResults from '../hooks/useSubscribeWidgetResults';
import { hasAnySelectionData, hasSelections } from '../../utils/selections';
import Loading from './Loading';
import settings, { selectionConfig } from './settings';
import StyleVariables, { getSectionAttr, getSectionAttrSelector } from '../../misc/StyleVariables';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ArrowRightIcon = function ArrowRightIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.29286 6.29289C7.90234 6.68342 7.90234 7.31658 8.29286 7.70711L12.5858 12L8.29286 16.2929C7.90234 16.6834 7.90234 17.3166 8.29286 17.7071C8.68339 18.0976 9.31655 18.0976 9.70708 17.7071L15.4142 12L9.70708 6.29289C9.31655 5.90237 8.68339 5.90237 8.29286 6.29289Z",
      fill: "#12131A"
    })
  }));
};

ArrowRightIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const List = _ref => {
  let {
    widgetId,
    sectionId,
    reportingWidgetId,
    elementId,
    editing = false,
    config,
    onCtaClick,
    showCta,
    isLargeContainer
  } = _ref;
  const {
    seriesOptions = [],
    ctaButton,
    ctaButtonColor,
    ctaPrompt,
    selections = '',
    // selectionsStrategy = '',
    selectionsLabeled = false,
    globalSeriesOptions = {}
  } = config; // Get results from reporting widget

  const results = useSubscribeWidgetResults(reportingWidgetId); // Get relevant results for each selection group

  const {
    selectionResults
  } = useSelections({
    results,
    selections,
    selectionConfig,
    selectionsLabeled
  });
  const isLarge = isLargeContainer; // Data & Loading States

  const hasNoData = !hasAnySelectionData(selectionResults);
  const isLoading = !results.length;
  const needSelectionEditing = editing && !hasSelections(selections); // Combine results with rendering styles

  const {
    data
  } = useData(selectionResults, seriesOptions, globalSeriesOptions);
  let ctaButtonStyles = '';

  if (ctaButtonColor && typeof ctaButtonColor === 'string') {
    ctaButtonStyles += `background-color: ${ctaButtonColor} !important; border-color: ${ctaButtonColor} !important;`;
  }

  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, elementId && {
    id: elementId
  }), {}, {
    className: clsx(styles.container, isLarge ? styles['container--large'] : '')
  }, getSectionAttr(widgetId, sectionId)), needSelectionEditing ? {
    [getEditingAreaAttr()]: 'na'
  } : null), {}, {
    children: [/*#__PURE__*/_jsx(Header, {
      editing: editing,
      config: config,
      sectionId: sectionId,
      widgetId: widgetId
    }), isLoading || hasNoData ? /*#__PURE__*/_jsx(Loading, {
      editing: editing
    }) : data.length ? /*#__PURE__*/_jsx("ul", {
      className: styles.list,
      children: data.map((item, index, array) => /*#__PURE__*/_jsx(Item, {
        label: item.label,
        value: item.value,
        text: item.text,
        hasSeparator: item.separator,
        color: item.color,
        isLast: index === array.length - 1,
        selection: item.selection,
        selectionIndex: item.selectionIndex,
        editing: editing
      }, index))
    }) : /*#__PURE__*/_jsx(_Fragment, {}), showCta && ctaButton && /*#__PURE__*/_jsxs("footer", {
      className: styles.footer,
      children: [ctaButtonColor ? /*#__PURE__*/_jsx("style", {
        type: "text/css",
        children: `.${styles.footer__action},${styles.footer__action}:hover {${ctaButtonStyles}}`
      }) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsx(Button, {
        variant: "primary",
        className: styles.footer__action,
        rightIcon: /*#__PURE__*/_jsx(ArrowRightIcon, {}),
        onClick: onCtaClick,
        children: ctaButton
      }), /*#__PURE__*/_jsx("p", {
        className: styles.footer__info,
        children: ctaPrompt
      })]
    }), /*#__PURE__*/_jsx(StyleVariables, {
      selector: getSectionAttrSelector(widgetId, sectionId),
      data: _objectSpread(_objectSpread({}, settings.styles), config.styles || {})
    })]
  }));
};

export default List;
export { settings, selectionConfig };